import api from "@/api";
import converters from "@/converters";
import type { GroupFragment } from "@/graphql";
import { Grouptype, Module_Type } from "@/graphql/generated-types";
import isDataReady from "@/helpers/requests/isDataReady";
import type { LoadingType } from "@/types";
import { computed, ref } from "vue";

const groups = ref<GroupFragment[]>([]);
const status = ref<LoadingType>("none");

export function useGroups(moduleType: Module_Type) {
  const init = async () => {
    if (status.value === "loaded") {
      return;
    }

    status.value = "loading";
    const data = await api.groups.getGroups();
    groups.value = data.institutions?.getMyInstitution.groups || [];
    status.value = "loaded";
  };

  init();

  const groupList = computed(() => {
    return groups.value
      .filter((item) => item.groupType === Grouptype.Standard)
      .map(converters.groups.toMultiSelectItem);
  });

  const groupOptions = computed(() => {
    return groups.value.map(converters.groups.toOption);
  });

  const parentGroupList = computed(() => {
    return groups.value
      .filter(
        (item) =>
          item.groupType === Grouptype.RelativeDepartment &&
          item.moduleTypes.includes(moduleType),
      )
      .map(converters.groups.toMultiSelectItem)
      .map((item) => {
        return {
          ...item,
          icon: "ibg-icon ibg-handsheart",
        };
      });
  });

  const loading = computed(() => {
    return status.value === "loading";
  });

  const isReady = () => isDataReady(status);

  return {
    groups,
    groupList,
    groupOptions,
    parentGroupList,
    loading,
    isReady,
  };
}
